export default {
    InternalReturnRefundNoteDetails: {
        Return: '退货物流',
        Logistics: '物流信息',
        reviewed: '待审核、待买家退货才能修改',
        warehouse: '退货仓库',
        Warehousing: '入库通知单',
        Receipt: '入库结果单',
        Financial: '财务信息',
        Settlement: '结算方式',
        Add: '添加标签',
        Associated: '关联单据',
        Internal: '内部退货单号',
        Third: '三方退换单号',
        order: '客户订单号',
        number: '内部订单号',
        creation: '内部创单时间',
        time: '三方退货时间',
        receipttime: '退货入库时间',
        Completion: '完成时间',
        Picture: '图片附件',
        Upload: '上传',
        Product: '商品信息',
        refund: '添加退货退款商品',
        Select: '选择退货退款的商品',
        Other: '其它',
        Quantity: '已发货数量：',
        Returned: '已退货数量：',
        Returnable: '可退货数量：',
        Shipment: '发货状态：',
        Preemption: '预占状态：',
        Sourcing: '寻源状态：',
        Delete: '删除',
    }
};
